import styled from 'styled-components';

const MIN_AMOUNT = 'min_amount';
const MAX_AMOUNT = 'max_amount';
const BASE_RATE_KEY_TYPE = 'base_rate_type';
const BASE_RATE_KEY_VALUE = 'base_rate_value';
const COMMERCIAL_KEY_TYPE = 'commercial_type';
const COMMERCIAL_KEY_VALUE = 'commercial_value';

const RUPEE_SIGN = '₹';
const INFINITY_SIGN = '∞';
const PERCENTAGE_SIGN = '%';
const PERCENTAGE = 'PERCENTAGE';
const FLAT = 'FLAT';

const selectCommissionMode = 'neft';
const selectCommissionModeTransactionAmount = 1000;
const maxTransactionAmount = 1000000;

const CommissionCalculatorModesOptions = [
  {
    value: 'neft',
    label: 'NEFT'
  },
  {
    value: 'rtgs',
    label: 'RTGS'
  },
  {
    value: 'imps',
    label: 'IMPS'
  },
  {
    value: 'upi',
    label: 'UPI'
  }
];

const TYPE = [
  {
    value: 'PERCENTAGE',
    label: 'PERCENTAGE'
  },
  {
    value: 'FLAT',
    label: 'FLAT'
  }
];

const TypographyTitle = styled.h1`
  font-weight: 500;
  font-size: 14px;
`;

const TypographyTitleSign = styled.h1`
  font-weight: 500;
  font-size: 24px;
`;

const TypographyTextPara = styled.p`
  font-weight: 500;
  font-size: 14px;
`;

export {
  MIN_AMOUNT,
  MAX_AMOUNT,
  BASE_RATE_KEY_TYPE,
  BASE_RATE_KEY_VALUE,
  COMMERCIAL_KEY_TYPE,
  COMMERCIAL_KEY_VALUE,
  CommissionCalculatorModesOptions,
  TYPE,
  RUPEE_SIGN,
  PERCENTAGE_SIGN,
  PERCENTAGE,
  FLAT,
  TypographyTitle,
  TypographyTitleSign,
  TypographyTextPara,
  selectCommissionMode,
  selectCommissionModeTransactionAmount,
  maxTransactionAmount,
  INFINITY_SIGN
};
